import * as React from "react";
import Button from "@material-ui/core/Button";
import { API } from "../../../../utilities/api.config";
import { connect } from "react-redux";
import Axios from "axios";
import { downloadBlob } from "../../../../utilities/download-blob";

class DownloadDisclosure extends React.Component {
  state = {
    isDownloading: false,
  };

  /**
   * 
   * @param {string} appName 
   */
  downloadDocument = (appName) => {
    this.setState({ isDownloading: true }, () => {
      Axios
        .get(API.DOWNLOAD_DISCLOSURE, { responseType: 'blob' })
        .then((response) => response.data)
        .then((blob) => downloadBlob(blob, `Disclosures.pdf`))
        .then(() => {
          this.setState({ isDownloading: false });
          this.props.onDownloaded();
        })
        .catch((err) => {
          this.setState({ isDownloading: false });
        });
    });
  };

  render() {
    const { appName } = this.props;
    return (
      <React.Fragment>
        <Button
          variant="outlined"
          color="primary"
          onClick={() =>
            this.downloadDocument(appName)
          }
        >
          Download Disclosures
        </Button>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    appName: state.app.appName,
  };
};

export default connect(mapStateToProps)(DownloadDisclosure);



// WEBPACK FOOTER //
// ./src/components/OnboardPortfoliosDialog/components/DownloadDisclosure/index.jsx